export default "__VITE_ASSET__BpDg0_3Y__"